import * as moment from 'moment';

// Interfaces
import {
    IActivitiesInfo,
    IActivitiesGroup,
    IActivityShort,
    IActivity,
    IActivities,
    IActivityTypeApi,
    ICreateActivity,
    NewActivityStatus,
} from 'common/interfaces/activity';

export class ActivitiesMethods {
    public static parseActivitiesGroups = (
        activities: IActivity[]
    ): IActivitiesGroup[] => {
        const now = moment();

        const completeGroup: IActivitiesGroup = {
            title: 'Complete',
            key: 'complete',
            allFinished: true,
            activities: [],
        };
        const pastDueGroup: IActivitiesGroup = {
            title: 'Past due',
            key: 'pastdue',
            allFinished: false,
            activities: [],
        };
        const beforeTodayGroup: IActivitiesGroup = {
            title: 'In the past',
            key: 'pastdue',
            allFinished: false,
            activities: [],
        };
        const todayGroup: IActivitiesGroup = {
            title: 'Today',
            key: 'today',
            allFinished: true,
            activities: [],
        };
        const tomorrowGroup: IActivitiesGroup = {
            title: 'Tomorrow',
            key: 'tomorrow',
            allFinished: true,
            activities: [],
        };
        const thisWeekGroup: IActivitiesGroup = {
            title: 'Later this week',
            key: 'thisweek',
            allFinished: true,
            activities: [],
        };
        const nextWeekGroup: IActivitiesGroup = {
            title: 'Next week',
            key: 'nextweek',
            allFinished: true,
            activities: [],
        };
        const futureGroup: IActivitiesGroup = {
            title: 'In the future',
            key: 'future',
            allFinished: true,
            activities: [],
        };
        const noDateGroup: IActivitiesGroup = {
            title: 'No due date',
            key: 'nodue',
            allFinished: false,
            activities: [],
        };

        let completeGroupFinishedCount: number = 0;
        let pastDueGroupFinishedCount: number = 0;
        let beforeTodayGroupFinishedCount: number = 0;
        let todayGroupFinishedCount: number = 0;
        let tomorrowGroupFinishedCount: number = 0;
        let thisWeekGroupFinishedCount: number = 0;
        let nextWeekGroupFinishedCount: number = 0;
        let futureGroupFinishedCount: number = 0;
        let noDateGroupFinishedCount: number = 0;

        if (activities) {
            const today = now.clone().startOf('day');
            const tomorrow = now
                .clone()
                .subtract(-1, 'days')
                .startOf('day');

            const isPastDue = (date: moment.Moment) =>
                date.isBefore(today, 'd');
            const isToday = (date: moment.Moment) => date.isSame(today, 'd');
            const isTomorrow = (date: moment.Moment) =>
                date.isSame(tomorrow, 'd');
            const isInThisWeek = (date: moment.Moment) =>
                date.isBetween(
                    tomorrow.endOf('day'),
                    moment().endOf('isoWeek')
                );
            const isInNextWeek = (date: moment.Moment) =>
                date.isBetween(
                    moment()
                        .add(1, 'weeks')
                        .startOf('isoWeek'),
                    moment()
                        .add(1, 'weeks')
                        .endOf('isoWeek')
                );
            const isInFuture = date =>
                date.isAfter(
                    moment()
                        .add(1, 'weeks')
                        .endOf('isoWeek')
                );

            activities.map(activity => {
                const activityShort: IActivityShort = {
                    id: activity.id,
                    time: activity.activityTime
                        ? moment(activity.activityTime)
                        : null,
                    title: activity.activityType.name,
                    note: activity.note,
                    author: activity.createdByUser,
                    assignedToUser: activity.assignedToUser,
                    provider: activity.provider,
                    finished: activity.finished,
                    savingComplete: activity.savingComplete,
                };

                if (activityShort.finished) {
                    completeGroupFinishedCount++;
                    completeGroup.activities.push(activityShort);
                } else if (activityShort.time === null) {
                    noDateGroupFinishedCount += activity.finished ? 1 : 0;
                    noDateGroup.activities.push(activityShort);
                } else if (
                    isPastDue(activityShort.time) &&
                    !activityShort.finished
                ) {
                    pastDueGroupFinishedCount += activity.finished ? 1 : 0;
                    pastDueGroup.activities.push(activityShort);
                } else if (
                    isPastDue(activityShort.time) &&
                    activityShort.finished
                ) {
                    beforeTodayGroupFinishedCount += activity.finished ? 1 : 0;
                    beforeTodayGroup.activities.push(activityShort);
                } else if (isToday(activityShort.time)) {
                    todayGroupFinishedCount += activity.finished ? 1 : 0;
                    todayGroup.activities.push(activityShort);
                } else if (isTomorrow(activityShort.time)) {
                    tomorrowGroupFinishedCount += activity.finished ? 1 : 0;
                    tomorrowGroup.activities.push(activityShort);
                } else if (isInThisWeek(activityShort.time)) {
                    thisWeekGroupFinishedCount += activity.finished ? 1 : 0;
                    thisWeekGroup.activities.push(activityShort);
                } else if (isInNextWeek(activityShort.time)) {
                    nextWeekGroupFinishedCount += activity.finished ? 1 : 0;
                    nextWeekGroup.activities.push(activityShort);
                } else if (isInFuture(activityShort.time)) {
                    futureGroupFinishedCount += activity.finished ? 1 : 0;
                    futureGroup.activities.push(activityShort);
                }
            });
        }

        const r = [];
        if (completeGroup.activities.length > 0) {
            completeGroup.allFinished =
                completeGroup.activities.length <= completeGroupFinishedCount;
            r.push(completeGroup);
        }
        if (pastDueGroup.activities.length > 0) {
            pastDueGroup.allFinished =
                pastDueGroup.activities.length <= pastDueGroupFinishedCount;
            r.push(pastDueGroup);
        }
        if (beforeTodayGroup.activities.length > 0) {
            beforeTodayGroup.allFinished =
                beforeTodayGroup.activities.length <=
                beforeTodayGroupFinishedCount;
            r.push(beforeTodayGroup);
        }
        if (todayGroup.activities.length > 0) {
            todayGroup.allFinished =
                todayGroup.activities.length <= todayGroupFinishedCount;
            r.push(todayGroup);
        }
        if (tomorrowGroup.activities.length > 0) {
            tomorrowGroup.allFinished =
                tomorrowGroup.activities.length <= tomorrowGroupFinishedCount;
            r.push(tomorrowGroup);
        }
        if (thisWeekGroup.activities.length > 0) {
            thisWeekGroup.allFinished =
                thisWeekGroup.activities.length <= thisWeekGroupFinishedCount;
            r.push(thisWeekGroup);
        }
        if (nextWeekGroup.activities.length > 0) {
            nextWeekGroup.allFinished =
                nextWeekGroup.activities.length <= nextWeekGroupFinishedCount;
            r.push(nextWeekGroup);
        }
        if (futureGroup.activities.length > 0) {
            futureGroup.allFinished =
                futureGroup.activities.length <= futureGroupFinishedCount;
            r.push(futureGroup);
        }
        if (noDateGroup.activities.length > 0) {
            noDateGroup.allFinished =
                noDateGroup.activities.length <= noDateGroupFinishedCount;
            r.push(noDateGroup);
        }

        return r;
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/methods/activities.ts